const config = {
    baseURL: process.env.NODE_ENV === 'production' ? process.env.PUBLIC_URL : 'http://localhost:3000',
    scd_url: 'https://scd.siemens.cloud/de/person/',
    reportingServerUrl: '/report/rest_v2/reports/Reports/',
    version: '2.0.2',
}
export default config